import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row, Card, CardBody, Button } from "reactstrap";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { Save, ArrowLeft } from "react-feather";

const AddEdit_ChargeTypeMaster = () => {
  const API_URL_SAVE = "ChargeTypeMaster/0/token";
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/ChargeTypeMaster/Id";
  const API_URL_USER_TYPE = `${API_WEB_URLS.MASTER}/0/token/UserTypeMaster/Id/0`;
  const API_URL_CALCULATION_BASE = `${API_WEB_URLS.MASTER}/0/token/CalculationBaseMaster/Id/0`;
  const API_URL_CALCULATION_TYPE = `${API_WEB_URLS.MASTER}/0/token/CalculationTypeMaster/Id/0`;
  const API_URL_CHARGE_CATEGORY = `${API_WEB_URLS.MASTER}/0/token/ChargeCategoryMaster/Id/0`;
  const API_URL_SYSTEM_LEDGERS = `${API_WEB_URLS.MASTER}/0/token/SystemLedgers/Id/0`;

  const [state, setState] = useState({
    id: 0,
    formData: {
      ChargeName: "",
      F_ChargeCategory: "",
      F_UserTypeMaster: "",
      F_CalculationType: "",
      ChargeValue: "",
      F_CalculationBase: "",
      F_LedgerMaster: "",
      IsActive: true,
    },
  });

  const [userTypeList, setUserTypeList] = useState([]);
  const [calculationBaseList, setCalculationBaseList] = useState([]);
  const [calculationTypeList, setCalculationTypeList] = useState([]);
  const [chargeCategoryList, setChargeCategoryList] = useState([]);
  const [ledgerList, setLedgerList] = useState([]);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const nameRef = useRef(null);

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prevState) => ({ ...prevState, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  useEffect(() => {
    Fn_FillListData(dispatch, setUserTypeList, "gridData", API_URL_USER_TYPE);
    Fn_FillListData(dispatch, setCalculationBaseList, "gridData", API_URL_CALCULATION_BASE);
    Fn_FillListData(dispatch, setCalculationTypeList, "gridData", API_URL_CALCULATION_TYPE);
    Fn_FillListData(dispatch, setChargeCategoryList, "gridData", API_URL_CHARGE_CATEGORY);
    Fn_FillListData(dispatch, setLedgerList, "gridData", API_URL_SYSTEM_LEDGERS);
  }, [dispatch]);

  useEffect(() => {
    if (nameRef.current) nameRef.current.focus();
  }, []);

  const validationSchema = Yup.object({
    ChargeName: Yup.string().required("Charge name is required"),
    F_ChargeCategory: Yup.string().required("Charge category is required"),
    F_UserTypeMaster: Yup.string().required("User type is required"),
    F_CalculationType: Yup.string().required("Calculation type is required"),
    ChargeValue: Yup.number().required("Charge value is required").min(0, "Value must be 0 or greater"),
    F_CalculationBase: Yup.string().required("Calculation base is required"),
    F_LedgerMaster: Yup.string().required("Ledger is required"),
    IsActive: Yup.boolean(),
  });

  const handleSubmit = async (values) => {
    const obj = JSON.parse(localStorage.getItem("user"));
    let formData = new FormData();
    formData.append("ChargeName", values.ChargeName || "");
    formData.append("F_ChargeCategory", values.F_ChargeCategory || "");
    formData.append("F_UserTypeMaster", values.F_UserTypeMaster || "");
    formData.append("F_CalculationType", values.F_CalculationType || "");
    formData.append("ChargeValue", values.ChargeValue ?? "");
    formData.append("F_CalculationBase", values.F_CalculationBase || "");
    formData.append("F_LedgerMaster", values.F_LedgerMaster || "");
    formData.append("IsActive", values.IsActive !== false);
    formData.append("UserId", obj === null || obj === undefined ? 0 : obj.uid);

    Fn_AddEditData(dispatch, setState, { arguList: { id: state.id, formData } }, API_URL_SAVE, true, "rateid", navigate, "/ChargeTypeMaster");
  };

  const str = (v) => (v !== undefined && v !== null ? String(v) : "");

  return (
    <div style={{ padding: "6px 8px", maxWidth: 900, margin: "0 auto" }}>
      <Card className="border shadow-none" style={{ marginBottom: 0 }}>
        <CardBody className="p-2" style={{ padding: "8px 12px !important" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6, paddingBottom: 4, borderBottom: "1px solid #dee2e6" }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>Charge Type Master</span>
            <div style={{ display: "flex", gap: 6 }}>
              <Button type="button" size="sm" color="light" className="py-1 px-2" style={{ fontSize: 12 }} onClick={() => navigate("/ChargeTypeMaster")}>
                <ArrowLeft size={12} className="me-1" />Back
              </Button>
              <Button type="submit" form="chargetype-form" size="sm" color="primary" className="py-1 px-2" style={{ fontSize: 12 }}>
                <Save size={12} className="me-1" />Save
              </Button>
            </div>
          </div>
          <Formik
            initialValues={{
              ChargeName: state.formData.ChargeName || "",
              F_ChargeCategory: str(state.formData.F_ChargeCategory),
              F_UserTypeMaster: str(state.formData.F_UserTypeMaster),
              F_CalculationType: str(state.formData.F_CalculationType),
              ChargeValue: state.formData.ChargeValue ?? "",
              F_CalculationBase: str(state.formData.F_CalculationBase),
              F_LedgerMaster: str(state.formData.F_LedgerMaster),
              IsActive: state.formData.IsActive !== false,
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ errors, touched }) => (
              <Form id="chargetype-form" style={{ marginTop: 4 }}>
                <Row style={{ gap: "0 8px", rowGap: 2 }}>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Name <span className="text-danger">*</span></label>
                    <Field innerRef={nameRef} className={`form-control form-control-sm ${errors.ChargeName && touched.ChargeName ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="text" name="ChargeName" placeholder="Name" />
                    <ErrorMessage name="ChargeName" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Charge Category <span className="text-danger">*</span></label>
                    <Field as="select" className={`form-select form-select-sm ${errors.F_ChargeCategory && touched.F_ChargeCategory ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="F_ChargeCategory">
                      <option value="">Select</option>
                      {chargeCategoryList && chargeCategoryList.map((item) => <option key={item.Id} value={item.Id}>{item.CategoryName || item.Id}</option>)}
                    </Field>
                    <ErrorMessage name="F_ChargeCategory" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>User Type <span className="text-danger">*</span></label>
                    <Field as="select" className={`form-select form-select-sm ${errors.F_UserTypeMaster && touched.F_UserTypeMaster ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="F_UserTypeMaster">
                      <option value="">Select</option>
                      {userTypeList && userTypeList.map((item) => <option key={item.Id} value={item.Id}>{item.Name || item.UserTypeName || item.Id}</option>)}
                    </Field>
                    <ErrorMessage name="F_UserTypeMaster" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Calc Type <span className="text-danger">*</span></label>
                    <Field as="select" className={`form-select form-select-sm ${errors.F_CalculationType && touched.F_CalculationType ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="F_CalculationType">
                      <option value="">Select</option>
                      {calculationTypeList && calculationTypeList.map((item) => <option key={item.Id} value={item.Id}>{item.TypeName || item.Id}</option>)}
                    </Field>
                    <ErrorMessage name="F_CalculationType" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Value <span className="text-danger">*</span></label>
                    <Field className={`form-control form-control-sm ${errors.ChargeValue && touched.ChargeValue ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="number" name="ChargeValue" placeholder="0" step="0.01" min="0" />
                    <ErrorMessage name="ChargeValue" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Calc Base <span className="text-danger">*</span></label>
                    <Field as="select" className={`form-select form-select-sm ${errors.F_CalculationBase && touched.F_CalculationBase ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="F_CalculationBase">
                      <option value="">Select</option>
                      {calculationBaseList && calculationBaseList.map((item) => <option key={item.Id} value={item.Id}>{item.BaseName || item.Id}</option>)}
                    </Field>
                    <ErrorMessage name="F_CalculationBase" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Ledger <span className="text-danger">*</span></label>
                    <Field as="select" className={`form-select form-select-sm ${errors.F_LedgerMaster && touched.F_LedgerMaster ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="F_LedgerMaster">
                      <option value="">Select</option>
                      {ledgerList && ledgerList.map((item) => <option key={item.Id} value={item.Id}>{`${item.LedgerName || item.LedgerCode || item.Id}${item.LedgerName && item.LedgerCode ? ` (${item.LedgerCode})` : ""}`}</option>)}
                    </Field>
                    <ErrorMessage name="F_LedgerMaster" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4, display: "flex", alignItems: "flex-end", paddingBottom: 4 }}>
                    <div className="form-check form-check-sm">
                      <Field className="form-check-input" type="checkbox" name="IsActive" id="IsActive" style={{ marginTop: 6 }} />
                      <label className="form-check-label" htmlFor="IsActive" style={{ fontSize: 11 }}>Active</label>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </div>
  );
};

export default AddEdit_ChargeTypeMaster;
